module.exports = __webpack_public_path__ + "img/competencies_swiper_11.3bc8370a.jpg";